/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BasePage from '../../../shared/BasePage';
import { apiFetch } from '../../../apiClient';
import { apiMap } from '../../../config/constants';
import StepIndicator from '../../../shared/StepIndicator';
import paths from '../../../config/path';
import history from '../../../utils/history';
import AOForm from '../../../shared/AOForm';
import FormTitle from '../../../shared/AOForm/components/FormTitle';
import PreviewQuestionBasicInfo from '../components/PreviewQuestionBasicInfo';
import PreviewQuestionAccount from '../components/PreviewQuestionAccount';
import ApplicationAndCompany from '../components/ApplicationAndCompany';
import { findQuestionById } from '../../../utils/AOFormUtils';
import { updateStep } from '../../CompanyRegistration/state/action';
import { SubmitPreview } from '../state/action';
import { setTitle } from '../../../utils';

import './style.css';

/* eslint-disable array-callback-return */
/* eslint-disable radix */
class Question extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        }
    }
    componentDidMount() {
        this.switchI18n();
        this.handleApplicationInfo(this.props);
    }
    componentWillReceiveProps = (nextProps) => {
        this.handleApplicationInfo(nextProps);
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.switchI18n();
        }
    }
    switchI18n = () => {
        apiFetch(apiMap.previewQuestion)().then( (i18n) => {
            this.setState({
                i18n
            });
        }).catch(error => {});
    }

    handleApplicationInfo = ({ businessInfo, applicationInfo, countryListDatas, industryLevelList }) => {
        if (applicationInfo && businessInfo && countryListDatas && industryLevelList) {
            const basicI18n = findQuestionById(applicationInfo, "S001");
            const accountI18n = findQuestionById(applicationInfo, "S002");
            const businessType = basicI18n.questions[1].subQuestions[1] && basicI18n.questions[1].subQuestions[1].userAnswer && basicI18n.questions[1].subQuestions[1].userAnswer.chosenAnswerId;
            const isApplicable = (businessType === 'A001-002-002:001' || businessType === 'A001-002-002:002');
            const idInfo = businessInfo.idInfo || {};
            const companyInfo = businessInfo.companyInfo || {};
            const industryLevel = industryLevelList.roots;
            let answerTmp = null;
            let level2Tmp = null;
            let idInfoI18n = {
                name: idInfo.name || '',
                idType: idInfo.idType || '',
                idNo: idInfo.idNo || '',
            }
            let companyI18n = {
                registerCountry: companyInfo.registerCountry || '',
                comDocType: companyInfo.comDocType || '',
                comDocNum: companyInfo.comDocNum || '',
            }
            if (idInfo.otherIdType) {
                idInfoI18n = {
                    ...idInfoI18n,
                    otherIdType: idInfo.otherIdType
                }
            }
            basicI18n.questions[1].subQuestions[0].answers = countryListDatas;
            
            basicI18n.questions[2].subQuestions.map((item) => {
                item.subQuestions && item.subQuestions.map((detailItem, index) => {
                    const { questionIndicator } = detailItem;
                    const choseIndex = answerTmp && (parseInt(answerTmp.split(/:/)[1]) - 1);
                    if (detailItem.userAnswer) {
                        if (questionIndicator === 'natureBusi') {
                            detailItem.answers = industryLevel;
                        } else if (questionIndicator === 'manufactures') {
                            detailItem.answers = industryLevel[choseIndex].children;
                            level2Tmp = industryLevel[choseIndex].children;
                        } else if (questionIndicator === 'thirdNature') {
                            detailItem.answers = level2Tmp[choseIndex].children;
                        }
                        answerTmp = detailItem.userAnswer && detailItem.userAnswer.chosenAnswerId;
                    }
                });
            });
            this.setState({
                basicI18n,
                accountI18n,
                idInfoI18n,
                companyI18n,
                staticData: countryListDatas,
                isApplicable
            })
        }
    }
    handleChangeToEdit = (event, type) => {
        event.preventDefault();
        event.stopPropagation && event.stopPropagation();
        if (type === 'basicInfo') {
            this.props.updateStep({progressIndex: 1});
        } else if (type === 'accountQuestion') {
            this.props.updateStep({progressIndex: 2});
        }
        history.push(paths[type].path);
    }
    onChangeNextSubmit = () => {
        this.props.SubmitPreview({"sectionId": ["001","002"]});
    }
    backAction = () => {
        history.push(paths.accountQuestion.path);
    }
    render() {
        const { selectedLanguage, appMessages, pageTitle } = this.props;
        const { i18n, basicI18n, accountI18n, idInfoI18n, companyI18n, staticData, isApplicable } = this.state;

        if (i18n && pageTitle) {
          setTitle( i18n.title + pageTitle);
        }

        return i18n && basicI18n && accountI18n ? (
            <div className="dynamic-form ao-form container pq-form preview-step">
                <StepIndicator currentStep={5} stepInfo={appMessages.stepInfo} stepTitle={appMessages.stepTitle} />
                <FormTitle content={{
                    title: {
                        text: i18n.title,
                        dataKey: 'preview-title'
                    },
                    subTitle: {
                        text: i18n.tip,
                        dataKey: 'preview-subTitle'
                    }
                }} />
                <div className="preview-container">
                    <ApplicationAndCompany
                        dataId="preview-application-form"
                        title={i18n.applicationTitle}
                        i18n={i18n}
                        content={idInfoI18n}
                    />
                    <ApplicationAndCompany
                        dataId="preview-company-form"
                        title={i18n.companyTitle}
                        i18n={i18n}
                        content={companyI18n}
                        staticData={staticData}
                        selectedLanguage = {selectedLanguage}
                    />
                    <PreviewQuestionBasicInfo
                        dataId="preview-basicInfo-form"
                        title={i18n.basicTitle}
                        modifyInfo={i18n.modifyInfo}
                        basicI18n={basicI18n}
                        selectedLanguage={selectedLanguage}
                        handleChangeToEdit={this.handleChangeToEdit}
                    />
                    <PreviewQuestionAccount
                        dataId="preview-account-form"
                        title={i18n.accountTitle}
                        modifyInfo={i18n.modifyInfo}
                        accountI18n={accountI18n}
                        selectedLanguage={selectedLanguage}
                        isApplicable={isApplicable}
                        handleChangeToEdit={this.handleChangeToEdit}
                    />
                </div>
                <AOForm.BottomButtonsGroup
                    saveButtonShow = {false}
                    content={i18n.bottomButtonsContent}
                    backAction={this.backAction}
                    completeFormAction={this.onChangeNextSubmit}
                />
            </div>
        ) : null
    }
}

Question.propTypes = {
    selectedLanguage: PropTypes.string,
};

const mapStateToProps = (state) => ({
    countryListDatas: state.app.countryListDatas,
    industryLevelList:state.app.industryLevelList,
    applicationInfo: state.app.applicationInfo,
    selectedLanguage: state.app.selectedLanguage,
    businessInfo: state.app.businessInfo,
    appMessages: state.app.i18n,
    isChangeStatus: state.previewQuestion.isChangeStatus,
    pageTitle: state.app.i18n.pageTitle
});

export default connect(mapStateToProps, {
    updateStep,
    SubmitPreview
})(Question)


// WEBPACK FOOTER //
// ./src/views/PreviewQuestion/container/PreviewQuestion.js